import { gql } from '@apollo/client';
const ADD_PRODUCT_COUNTRY = gql `
  mutation AddProductCountry($name: String!, $description: String, $continentId: ID) {
    addProductCountry(name: $name, description: $description, continentId: $continentId) {
      productCountry {
        id
        name
        description
        continent {
          id
          name
        }
      }
    }
  }
`;
export default ADD_PRODUCT_COUNTRY;
